import React from 'react';
import AsyncApiDocument from './apidocument/async';
import AsyncConfiguration from './configuration/async';
import AsyncIntegration from './apiintegration/async';
import AsyncPlatforms from './platforms/async';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import {Redirect} from 'react-router';
import {Trans} from 'react-i18next';
import reports from './reports/routes';

const parent = {
  title: <Trans i18nKey="p.webmodule.title">Online Service</Trans>,
  path: '/web-module',
};

export default function Webmodule(accountSummary) {
  const getReport = reports(accountSummary);

  return [
    <SingleColumnLayout
      exact
      key="a"
      path="/web-module/api-document"
      component={AsyncApiDocument}
      title={<Trans i18nKey="p.w.api.document.title">API Integration</Trans>}
      parents={[parent]}
    />,
    <SingleColumnLayout
      exact
      key="b"
      path="/web-module/configuration"
      component={AsyncConfiguration}
      title={
        <div className="tutorial-config-module">
          <Trans i18nKey="p.w.configuration.title">Module Configuration</Trans>
        </div>
      }
      parents={[parent]}
    />,
    <SingleColumnLayout
      exact
      key="c"
      path="/web-module/api-integration"
      component={AsyncIntegration}
      title={<Trans i18nKey="p.w.api.document.title">API Integration</Trans>}
      parents={[parent]}
    />,
    <SingleColumnLayout
      exact
      key="d"
      path="/web-module/platforms"
      component={AsyncPlatforms}
      title={<Trans i18nKey="p.w.platforms.title">Platforms</Trans>}
      parents={[parent]}
    />,
    <Redirect key="e" exact from="/web-module" to="/" />,
    getReport,
  ];
}
